import { Badge } from "@/components/ui/badge";
import { PRIORITY, type ValueRenderer } from "../types";

export const BooleanRenderer: ValueRenderer = {
  id: "boolean",
  match: value => (typeof value === "boolean" ? { priority: PRIORITY.PRIMITIVE } : null),
  Component: ({ value }) => <Badge variant={value ? "success" : "destructive"}>{value ? "true" : "false"}</Badge>,
};
